/**
 * IMPORTS
 */

import { useCallback } from "react";

import { TriangleAlert, X } from "lucide-react";
import { toast } from "react-toastify";

// components
import { Button } from "@components/button/button";

// typings
import { IRecusarTarefaModalProps } from "@pages/admin/remessas/components/recusar-tarefa-modal/interface.d";

// hooks / react-query
import { useUpdateTarefa } from "@/hooks/minhas-tarefas/use-update-tarefa";

// hooks / zustand
import { useStoreZustandUserAuth } from "@/store-zustand/user-auth";

const RecusarTarefaModal = ({
  idRemessa,
  handleToggleCreateActvityModal,
  setCurrentScreen,
}: IRecusarTarefaModalProps) => {
  const { user } = useStoreZustandUserAuth();

  const { mutate: mutateUseUpdateTarefa, isPending } = useUpdateTarefa();

  const handleConfirmar = useCallback(() => {
    if (!user?.id) {
      toast.error("Usuário não autenticado.");
      return;
    }

    mutateUseUpdateTarefa(
      {
        id_remessa: Number(idRemessa),
        payload: {
          user_id_executor: user.id,
          situacao: "cancelada",
          status: "cancelada",
        },
      },
      {
        onSuccess: () => {
          handleToggleCreateActvityModal();
          setCurrentScreen();
        },
        onError: () => {
          handleToggleCreateActvityModal();
        },
      }
    );
  }, [
    idRemessa,
    user?.id,
    mutateUseUpdateTarefa,
    handleToggleCreateActvityModal,
    setCurrentScreen,
  ]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
      <div className="max-h-[90vh] w-[400px] space-y-5 rounded-xl bg-white px-6 py-6 shadow-shape">
        {/* Header */}
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-semibold text-zinc-800">Confirmar Ação</h2>
          <button onClick={handleToggleCreateActvityModal}>
            <X className="size-5 text-zinc-400" />
          </button>
        </div>

        {/* Icone + Texto */}
        <div className="flex flex-col items-center gap-2 text-center">
          <TriangleAlert className="text-yellow-500" size={32} />
          <p className="text-base font-medium text-zinc-700">
            Deseja realmente excluir esta tarefa?
          </p>
        </div>

        {/* Botões */}
        <div className="w-full justify-end gap-2 pt-4">
          <Button className="w-full" onClick={handleConfirmar} disabled={isPending}>
            {isPending ? "Recusando..." : "Confirmar"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export { RecusarTarefaModal };
